import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';
import { map, isEmpty, find } from 'lodash';
import { Grid, Col, Row } from 'react-bootstrap';
import { EmptyList } from './EmptyList';
import ReportListItem from './ReportListItem';
import ConfirmDeleteModal from './ConfirmDeleteModal';
import Filters from './Filters';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import PageHeader from '../../components/PageHeader';
import TitleBanner from '../../components/TitleBanner';
import lookerApi from '../../services/looker-api';

class ReportList extends React.Component {
  state = {
    filterByName: '',
    showConfirmDeleteModal: false,
    uuid: '',
    loading: false
  };

  componentDidMount() {
    const {
      blocked,
      userId,
      reportBuilderActions: { fetchReportList }
    } = this.props;

    document.title = 'My Reports | CVM Insights';

    if (blocked) return;

    fetchReportList(userId);
  }

  handleRedirectToEdit = uuid => () => {
    const {
      reportBuilderActions: { resetReport }
    } = this.props;

    resetReport();
    this.setState({ redirectTo: `/reports/${uuid}` });
  };

  handleOpenModal = uuid => () =>
    this.setState({ showConfirmDeleteModal: true, uuid });

  handleCloseModal = () =>
    this.setState({ showConfirmDeleteModal: false, uuid: null });

  handleConfirmDelete = async () => {
    const { uuid } = this.state;
    const {
      userId,
      reportBuilderActions: { fetchReportList }
    } = this.props;

    this.setState({ loading: true });
    const data = await lookerApi.deleteReport(uuid, userId);
    if (isEmpty(data)) {
      /* error occurred */
    }
    await fetchReportList(userId);
    this.setState({ loading: false, showConfirmDeleteModal: false });
  };

  handleFilterByName = e => this.setState({ filterByName: e.target.value });

  handleCreateNewReport = () => {
    const {
      reportBuilderActions: { resetReport }
    } = this.props;

    resetReport();
    this.setState({ redirectTo: `/report-builder` });
  };

  render() {
    const { redirectTo, filterByName, showConfirmDeleteModal } = this.state;

    const isLoading = this.state.loading || this.props.loading;
    const { reports } = this.props;
    const hasAnyActiveReports = !!find(
      reports,
      report => report.status !== 'disabled'
    );

    if (!isEmpty(redirectTo)) {
      return <Redirect to={redirectTo} />;
    }

    return (
      <React.Fragment>
        <ConfirmDeleteModal
          isOpen={showConfirmDeleteModal}
          onClose={this.handleCloseModal}
          onDelete={this.handleConfirmDelete}
        />
        <Grid className="tvt-my-reports">
          <Row>
            <Col xs={12} md={12} lg={12}>
              <TitleBanner>
                <PageHeader title="My Reports" />
                <Filters onChangeFilterByName={this.handleFilterByName} />
              </TitleBanner>
              <hr className="tvt-my-reports__hr" />
              {isLoading && <LoadingSpinner />}
              {!isLoading && (
                <div className="tvt-my-reports">
                  {!hasAnyActiveReports && (
                    <EmptyList onCreateReport={this.handleCreateNewReport} />
                  )}
                  {hasAnyActiveReports &&
                    map(reports, report =>
                      report.status !== 'disabled' &&
                      report.name.includes(filterByName) ? (
                        <ReportListItem
                          key={report.uuid}
                          {...report}
                          onEdit={this.handleRedirectToEdit(report.uuid)}
                          onDelete={this.handleOpenModal(report.uuid)}
                        />
                      ) : null
                    )}
                </div>
              )}
            </Col>
          </Row>
        </Grid>
      </React.Fragment>
    );
  }
}

ReportList.propTypes = {
  blocked: PropTypes.bool.isRequired,
  reports: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool.isRequired,
  reportBuilderActions: PropTypes.shape({
    resetReport: PropTypes.func.isRequired,
    fetchReportList: PropTypes.func.isRequired
  }).isRequired,

  userId: PropTypes.string.isRequired
};

export default ReportList;
